import { searchBiomarkers } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  SearchBiomarkersRequestT,
  SearchBiomarkersResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchSearchBiomarkers(
  request: SearchBiomarkersRequestT,
  signal?: AbortSignal
): Promise<SearchBiomarkersResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await searchBiomarkers(request, config);
  return lotusHealthZod.searchBiomarkersResponse.parse(response.data) as SearchBiomarkersResponseT;
}
